import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <>
    <path
      fill="currentColor"
      d="m 14.894 15.04 l 3.225 -5.642 c 0.267 -0.469 -0.294 -0.97 -0.73 -0.652 l -3.236 2.366 a 0.5 0.5 0 0 1 -0.634 -0.035 l -2.167 -1.993 a 1 1 0 0 0 -1.529 0.212 l -3.392 5.522 c -0.279 0.455 0.253 0.972 0.7 0.68 l 3.453 -2.25 a 0.5 0.5 0 0 1 0.611 0.05 l 2.154 1.982 a 1 1 0 0 0 1.545 -0.24 Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M 8.122 20.884 a 9.567 9.567 0 0 0 3.878 0.816 a 9.6 9.6 0 1 0 -8.373 -4.901 L 2.4 21.702 l 5.721 -0.818 Z"
      fill="none"
    />
  </>,
  'Facebook'
)
